import React from 'react';
import PropTypes from 'prop-types';

const BulkEditField = ({
  children = null,
  iconClassName = null,
  iconText = null,
}) => (
  <div className="vf-task__bulk-edit__field">
    {iconClassName ? (
      <div className="vf-task__bulk-edit__field__icon">
        <i className={iconClassName}>{iconText}</i>
      </div>
    ) : false}

    <div className="vf-task__bulk-edit__field__content">
      {children}
    </div>
  </div>
);

BulkEditField.displayName = 'Bulk Edit Field';

BulkEditField.propTypes = {
  children: PropTypes.node,
  iconClassName: PropTypes.string,
  iconText: PropTypes.string,
};

export default BulkEditField;
